import { Box, List, ListItemButton, ListItemText } from "@mui/material";

import type { FC } from "react";

const SECTIONS = [
  ["general", "General"],
  ["channels", "Channels"],
  ["limits", "Limits & Features"],
  ["integrations", "Integrations"],
] as const;

export const AccountDetailNav: FC<{ customDashboard?: boolean }> = ({ customDashboard }) => (
  <Box component="nav" sx={{ position: "sticky", top: 24, alignSelf: "flex-start", minWidth: 200 }}>
    <List dense>
      {[
        ...SECTIONS,
        ...(customDashboard ? [["custom-luzmo-dashboard", "Custom Dashboard"]] : []),
      ].map(([id, label]) => (
        <ListItemButton
          key={id}
          onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
        >
          <ListItemText primary={label} />
        </ListItemButton>
      ))}
    </List>
  </Box>
);
